import { graphql, useStaticQuery } from "gatsby";

export const FormMentoriaTalentoQuery = () => {
    return useStaticQuery(graphql`
        query contentfulFormMentoriaTalento {
            form: allContentfulContactenos(
                filter: { contentful_id: { eq: "7xEBkOWoXdBrij8LwB4rDN" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    tituloFormulario
                    titulosFormulario {
                        tituloGeneral
                        descripcion {
                            raw
                        }
                        referenciaFormulario {
                            tipoCampo
                            listaSelect
                            mensajeError
                            inputPrincipal
                            nombreId
                            tituloBotonTerminos
                            textoTerminos {
                                raw
                            }
                            obligatorio
                            seccion
                            tabOrder
                            deshabilitado
                            placeholder
                            fieldMandatory
                        }
                        tituloBoton
                    }
                }
            }
            modalSuccess: allContentfulContactenos(
                filter: { contentful_id: { eq: "Qlvlhh0iEkcjRtKdkGMlv" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
            modalSuccessVariants: allContentfulContactenos(
                filter: { contentful_id: { eq: "gB7RdQQPxihhWaL2tkd97" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    tituloBotonOpcional
                    redireccionBotonOpcional
                    contentful_id
                }
            }
            modalUnsuccess: allContentfulContactenos(
                filter: { contentful_id: { eq: "6Kb90vXLj6DTWFdIfm4XrH" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
            modalWithoutAge: allContentfulContactenos(
                filter: { contentful_id: { eq: "2MCMN2vRDLfvotbMmnLVgy" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }

        }
    `);
}
